import { Tag, Typography } from "antd";
import PropTypes from "prop-types";
import { get, isNil } from "lodash";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";

const { Text } = Typography;

const SECTION_KEYS = [
  { key: "unresolved", labelKey: "UNRESOLVED", color: "red", tone: "danger" },
  { key: "ambiguous", labelKey: "AMBIGUOUS", color: "orange", tone: "warning" },
  { key: "manual", labelKey: "MANUAL", color: "blue", tone: "secondary" },
];

const entryText = (entry) =>
  [get(entry, "dataField"), get(entry, "reason")]
    .filter((part) => !isNil(part) && part !== "")
    .join(" — ");

export const reportIssueCount = (report) =>
  isNil(report)
    ? 0
    : (get(report, "unresolved") || []).length +
      (get(report, "ambiguous") || []).length +
      (get(report, "manual") || []).length;

const BindingReport = ({ report }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PROCESS);
  const BINDING = t("BINDING_REPORT", { returnObjects: true });

  if (isNil(report)) return null;

  const detected =
    (get(report, "bound") || []).length +
    (get(report, "materialized") || []).length;
  const warnings = get(report, "warnings") || [];

  return (
    <div className="binding-report">
      <div className="binding-report__header">
        {report.ok ? (
          <Tag color="green">{BINDING.OK}</Tag>
        ) : (
          <Tag color="orange">{BINDING.REVIEW}</Tag>
        )}
        <Text type="secondary" className="canvas-editor__meta">
          {t("BINDING_REPORT.DETECTED", { count: detected })}
        </Text>
      </div>
      {SECTION_KEYS.map(({ key, labelKey, color, tone }) => {
        const entries = get(report, key) || [];
        if (entries.length === 0) return null;
        return (
          <div key={key} className="binding-report__section">
            <Tag color={color}>{`${BINDING[labelKey]} (${entries.length})`}</Tag>
            {entries.map((entry) => (
              <div key={entryText(entry)} className="binding-report__entry">
                <Text type={tone}>{entryText(entry)}</Text>
              </div>
            ))}
          </div>
        );
      })}
      {warnings.length > 0 && (
        <div className="binding-report__section">
          <Tag color="gold">
            {t("BINDING_REPORT.WARNINGS", { count: warnings.length })}
          </Tag>
          {warnings.map((warning) => (
            <div key={warning} className="binding-report__entry">
              <Text type="warning">{warning}</Text>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

BindingReport.propTypes = {
  report: PropTypes.object,
};

BindingReport.defaultProps = {
  report: null,
};

export default BindingReport;
